import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TimePickerComponent } from '../time-picker/time-picker.component';
import { ClickAndKeydownDirective } from '@directives/click-and-keydown.directive';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'time-picker-dialog',
    templateUrl: 'time-picker-dialog.component.html',
    styleUrls: ['time-picker-dialog.component.less'],
    imports: [MatIconButton, MatDialogClose, MatIcon, TimePickerComponent, FormsModule, ReactiveFormsModule, MatButton, ClickAndKeydownDirective, TranslateModule]
})
export class TimePickerDialogComponent implements OnInit {
    dialogRef = inject<MatDialogRef<TimePickerDialogComponent>>(MatDialogRef);
    args = inject(MAT_DIALOG_DATA);

    form: UntypedFormControl;

    ngOnInit(): void {
        this.form = new UntypedFormControl(this.args);
    }

    save(): void {
        const result = this.form.value;
        this.dialogRef.close(result);
    }
}
